// src/components/PhotoSet.ts
import { LitElement, html } from 'lit';

enum PhotoRating {
  G = "g",
  PG13 = "pg13",
  R = "r",
  X = "x",
}

export class PhotoSet extends LitElement {
  createRenderRoot() {
    return this; // use light DOM so Tailwind styles apply
  }

  static properties = {
    id: { type: String },
    title: { type: String },
    description: { type: String },
    images: { type: Array<{ thumbnailSrc: string; src: string; rating: PhotoRating; }> },
  }

  constructor() {
    super()
    this.title = '';
    this.id = '';
    this.description = '';
    this.images = '';
    this.currentIndex = 0;
  }

  selectImage(index: number) {
    this.currentIndex = index;
    this.requestUpdate()
  }

  render() {
    return html`
      <div class="card bg-base-100 shadow-xl mb-8 animate-fade-in">
        <figure class="h-72 sm:h-96 overflow-hidden">
          <img class="w-full h-full object-contain" 
               src="${this.images[this.currentIndex]?.src}" 
               loading="lazy" 
               alt="${this.title}" />
        </figure>
        <div class="card-body">
          <h2 class="card-title">
            <a href="/photoset/${this.id}" class="underline hover:text-primary">${this.title}</a>
          </h2>
          <p>${this.description}</p>

          <!-- Thumbnails Row -->
          <div class="overflow-x-auto mt-4">
            <div class="flex gap-2 min-w-full pb-2 pr-4">
              ${this.images.map((img, i) => 
                img.rating === PhotoRating.G ? html`
                  <img
                    class="w-16 h-16 object-cover cursor-pointer border 
                           ${i === this.currentIndex ? 'border-primary' : 'border-base-300'} 
                           rounded-md flex-shrink-0 hover:scale-105 transition-transform duration-200"
                    src="${img.thumbnailSrc}" loading="lazy" alt=""
                    @click=${() => this.selectImage(i)}
                  />
                ` : ''
              )}
            </div>
          </div>

          <!-- CTA Button -->
          <div class="mt-6 text-center">
            <a href="/photoset/${this.id}" class="btn btn-primary btn-wide shadow-md max-w-none">
              View The Full Photoshoot ➡️
            </a>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('photo-set', PhotoSet);
